import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import bitmapFonts from 'src/lib/bitmapFonts';
import View from '@play-co/timestep-core/lib/ui/View';
import { getScreenTop } from 'src/lib/utils';
import StateObserver from 'src/StateObserver';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupOpenCrate extends PopupBasic {
  private bottomContainer: View;

  constructor(opts: { superview: View; close: () => void }) {
    super({
      superview: opts.superview,
      close: opts.close,
      zIndex: 10000,
      width: 443,
      height: 155,
      skipTitle: true,
      boxOpts: {
        image: 'assets/ui/conversation/thoughtbubble.png',
        scaleMethod: 'contain',
      },
      tracking: {
        feature: Feature.BPOINTS_FROM_PUZZLE._,
        $subFeature: Feature.BPOINTS_FROM_PUZZLE.OPEN_CRATE_POPUP,
      },
    });

    this.buttonClose.removeFromSuperview();

    this.bg.updateOpts({
      backgroundColor: undefined,
      image: 'assets/ui/shared/frames/popup_overlay.png',
      scaleMethod: 'contain',
      verticalAlign: 'bottom',
    });

    this.message.updateOpts({
      color: '#91808C',
      size: 30,
      width: this.box.style.width - 60,
      height: this.box.style.height - 30,
      x: 30,
      y: 10,
      wordWrap: false,
    });

    const width = uiConfig.width - 80;
    this.bottomContainer = this.box.addSubview(
      new View({
        height: 275,
        width,
        x: this.box.style.width / 2,
        centerOnOrigin: true,
      }),
    );

    this.bottomContainer.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.secondary,
        labelOffsetX: -4,
        labelOffsetY: -1,
        fontSize: 38,
        font: bitmapFonts('Body'),
        x: width / 2,
        y: 110,
        width: 240,
        height: 90,
        centerOnOrigin: true,
        localeText: () => i18n('puzzleCoins.openCrate.accept'),
        onClick: async () => {
          sounds.playSound('ok');
          opts.close();
        },
        tracking: {
          feature: Feature.BPOINTS_FROM_PUZZLE._,
          $subFeature: Feature.BPOINTS_FROM_PUZZLE.OPEN_CRATE_ACCEPT,
        },
      }),
    );
  }

  protected getAssetsGroup() {
    return new AssetGroup([
      'assets/ui/conversation/thoughtbubble.png',
      'assets/ui/shared/frames/popup_overlay.png',
    ]);
  }

  public init() {
    super.init({
      message: i18n('puzzleCoins.openCrate.message'),
    });

    const { screenSize } = StateObserver.getState().ui;
    const y = uiConfig.height * 0.4;
    this.box.updateOpts({ y });
    this.bottomContainer.updateOpts({
      y: getScreenTop() + screenSize.height - 250 - y,
      offsetY: 0,
    });
  }
}
